import {createAsyncThunk} from "@reduxjs/toolkit";
import {RootState} from "../../../store";
import {handlerError} from "../../../store/handleError";
import {INewTracker, INewTrackerPayment, ITracker} from "../../../models/ITracker";
import {trackersAPI} from "../api";
import {setModalMessage} from "../../messages/model/slice";

export const fetchAddTracker = createAsyncThunk<
    ITracker, INewTracker, { state: RootState }
>(
    "trackers/add",
    async (tracker: INewTracker, {rejectWithValue, dispatch}) => {
        try {
            return await trackersAPI.add(tracker);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchGetAllTracker = createAsyncThunk(
    "trackers/get_all",
    async (_, {rejectWithValue,dispatch}) => {
        try {
            return await trackersAPI.getAll();
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchGetTrackerById = createAsyncThunk(
    "trackers/get_by_id",
    async (trackerId: string, {rejectWithValue, dispatch}) => {
        try {
            return await trackersAPI.getById(trackerId);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchUpdateTracker = createAsyncThunk(
    "tracker/update",
    async (tracker: ITracker, {rejectWithValue, dispatch}) => {
        try {
            return await trackersAPI.update(tracker);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchDeleteTracker = createAsyncThunk(
    "tracker/remove",
    async (trackerId: string, {rejectWithValue, dispatch}) => {
        try {
            return await trackersAPI.delete(trackerId);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchAddTrackerPayment = createAsyncThunk<
    ITracker, { trackerId: string; payment: INewTrackerPayment }, { state: RootState }
>(
    "tracker/add_payment",
    async ({trackerId, payment}, {rejectWithValue, dispatch}) => {
        try {
            return await trackersAPI.addPayment(trackerId, payment);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchDeleteTrackerPayment = createAsyncThunk<
    ITracker, { trackerId: string; paymentId: string }, { state: RootState }
>(
    "tracker/delete_payment",
    async ({trackerId, paymentId}, {rejectWithValue, dispatch}) => {
        try {
            return await trackersAPI.deletePayment(trackerId, paymentId);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);